module.exports = __webpack_public_path__ + "static/media/phone-call.bbb818a2.png";